import Template from '../../component/Template.js';
import { useEffect, useRef } from 'react';
import Api from '../../component/Api';
import { useState } from 'react';
import React from "react";
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import '../../Assets/css/resptable.css'
import '../../Assets/css/responsiveptable.css'
import 'datatables.net';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';


export default function ChangePaaswordQuestionPaperDownload() {
  const navigate = useNavigate();
  const isAuth = useAuth();

  if (isAuth === false) {
    navigate("/college/");
  }


  const [responseData, setResponseData] = useState([]);
  const [loading, setlodaing] = useState(false);

  const [otp, setOtp] = useState('');
  const [passprof, setPassprof] = useState('');
  const [passprofconf, setPassprofconf] = useState('');
  const [showPassprof, setShowPassprof] = useState(false); // State for password visibility {/*nov14*/}
  const [showPassprofConf, setShowPassprofConf] = useState(false); // State for confirm password visibility {/*nov14*/}

  const toggleShowPassprof = () => setShowPassprof(!showPassprof); {/*nov14*/}
  const toggleShowPassprofConf = () => setShowPassprofConf(!showPassprofConf); {/*nov14*/}

  const { http } = Api();


  let cid = localStorage.getItem("collegeid");
  const [maskedContact, setMaskedContact] = useState('');


  useEffect(() => {
    const fetchMaskedContact = async () => {
      try {
        const response = await http.get('/College/getCollegeMaskedContact');
        if (response.data) {
          setMaskedContact(response.data.principal_email_for_qp); // Adjust based on actual response structure
        } else {
          toast.error("Failed to load masked contact.");
        }
      } catch (error) {
        toast.error("Error fetching masked contact.");
      }
    };

    fetchMaskedContact();
  }, []); // Empty dependency array to run only on page load


  // Function to handle OTP API call
  const handleSendOtp = async () => {
    try {
      const response = await http.get(`/College/QPdwnpasswordotpmail`);
      if (response.data.http_status === 200 && response.data.status_code == "MSG12") {
        // Display fields when API call is successful
        setResponseData([1]);
        toast.success(response.data.message);
      } else {
        toast.error("Failed to send OTP.");
      }
    } catch (error) {
      if (error.response.data.http_status === 401 && error.response.data.status_code === "ERR9") {
        toast.error("Invalid Token");
        setTimeout(() => {
          navigate("/college/");
        }, 5000);
      } else if (error.response.data.http_status === 429 && error.response.data.status_code === "ERR33") {
        toast.error(error.response.data.message);
      } else {
        toast.error("Something went wrong");
      }
    }
  };

  // Function to handle password update API call
  const handleSubmit = async () => {
    if (passprof !== passprofconf) {
      toast.error("Passwords do not match!");
      return;
    }

    try {
      const response = await http.post(`/College/updateQpdownloadpassword`, {
        otp: otp,
        passprof: passprof,
        passprofconf: passprofconf,
      });

      if (response.data.http_status === 200 && response.data.status_code === "MSG12") {
        toast.success(response.data.message);
        setResponseData([]);
        setOtp('');
        setPassprof('');
        setPassprofconf('');
      } else {
        toast.error(response.data.message || "Failed to update password.");
      }
    } catch (error) {
      if (error.response.data.http_status === 401 && error.response.data.status_code === "ERR9") {
        toast.error("Invalid Token");
        setTimeout(() => {
          navigate("/college/");
        }, 5000);
      } else if (error.response.data.http_status === 422 && error.response.data.status_code === "ERR1") {
        toast.error(error.response.data.message);
      }
      else if (error.response.data.http_status === 401 && error.response.data.status_code === "ERR38") {
        toast.error(error.response.data.message);
      }
      else {
        toast.error(error.response.data.message);
      }
    }
  };


  return (
    <>
      <ToastContainer />
      <Template>

        {loading ? (
          <div className="container-fluid">
            <div className="row justify-content-center align-items-center">
              <div className="col-sm-12">
                <div className="card h-100">
                  <div className="card-body d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                    <div className="containeranimate">
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="my-page">

            <div className="container-fluid">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="col-md-12">
                      <div className="card-header">
                        <div className="py-3 d-flex justify-content-between align-items-center ">
                          <h5>Create/Change Password for Downloading Question Paper</h5>
                        </div>

                      </div>
                      <div className="card-body">
                        <div className="container">
                        <div className="row mb-4 hed-bak">
                            <div className="alert alert-light-info light alert-dismissible fade show text-dark border-left-wrapper" role="alert">
                            <div className="col-md-6">
                            <h6 className="hed-fnt-wt"> <i className="fa fa-phone" aria-hidden="true"></i> Exclusive QP support: 0481 2731011</h6>
                            </div>
                            <div className="col-md-6">
                            <h6 className="hed-fnt-wt" style={{ textAlign: 'right' }}> <i className="fa fa-envelope" aria-hidden="true"></i>  Email: qp@mgu.ac.in</h6>
                            </div>
                            </div>
                          </div>
                          <div>
                            <div className="row">
                            {(responseData === '' || responseData.length === 0) && (
                              <div className="col-md-8 m-b-10 txt-aln">
                              
                                  <button className="btn btn-outline-success" type="button" onClick={handleSendOtp}>
                                    Click here to send OTP to registered Email
                                  </button>
                                  
                                  
                                
                                 <p style={{textAlign:'center',fontSize:'12px'}}>(OTP will send to {maskedContact})</p> 
                              </div>
                              )}
                            </div>
                          </div>

                          {responseData && responseData.length > 0 ? (
                            <div>
                              {/* <div className="row">
                            <div className="col-md-8 m-b-10 txt-aln">
                              <button class="btn btn-outline-success" type="submit" onClick={() => setResponseData([0])} >Resend OTP to Registered Email</button>
                            </div>
                          </div> */}
                              <div className="row">
                                <div className="col-md-4">
                                  <label htmlFor="otp">OTP <span className="text-danger">*</span></label>
                                </div>
                                <div className="col-md-4">
                                  <input
                                    className="form-control input-air-primary"
                                    type="text"
                                    id="otp"
                                    name="otp"
                                    placeholder="OTP"
                                    value={otp}
                                    onChange={(e) => setOtp(e.target.value)}
                                  />
                                
                                </div>
                              </div>
                              {/*nov14-START*/}
                              <div className="row">
                                <div className="col-md-4">
                                  <label htmlFor="passprof">New Password <span className="text-danger">*</span></label>
                                </div>
                                <div className="col-md-4">
                                  <input
                                    className="form-control input-air-primary"
                                    type={showPassprof ? "text" : "password"}
                                    id="passprof"
                                    name="passprof"
                                    placeholder="Password"
                                    value={passprof}
                                    onChange={(e) => setPassprof(e.target.value)}
                                  />
                                  <button
                                  type="button"
                                  className="btn btn-sm position-absolute top-0 end-0"
                                  onClick={toggleShowPassprof}
                                >
                                  <i className={`fa ${showPassprof ? 'fa-eye' : 'fa-eye-slash'}`}></i>
                                </button>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-md-4">
                                  <label htmlFor="passprofconf">Confirm Password <span className="text-danger">*</span></label>
                                </div>
                                <div className="col-md-4">
                                  <input
                                    className="form-control input-air-primary"
                                    type={showPassprofConf ? "text" : "password"}
                                    id="passprofconf"
                                    name="passprofconf"
                                    placeholder="Confirm Password"
                                    value={passprofconf}
                                    onChange={(e) => setPassprofconf(e.target.value)}
                                  />
                                   <button
                                  type="button"
                                  className="btn btn-sm position-absolute top-0 end-0"
                                  onClick={toggleShowPassprofConf}
                                >
                                  <i className={`fa ${showPassprofConf ? 'fa-eye' : 'fa-eye-slash'}`}></i>
                                </button>
                                </div>
                              </div>
                              {/*nov14-END*/}
                              <div className="row">
                                <div className="col-md-8 txt-aln">
                                  <button
                                    className="btn btn-primary me-3 m-b-10"
                                    type="button"
                                    onClick={handleSubmit}
                                    style={{ width: '140px' }}
                                  >
                                    Submit
                                  </button>
                                  <input
                                    className="btn btn-outline-secondary m-b-10"
                                    type="reset"
                                    value="Reset"
                                    onClick={() => {
                                      setOtp('');
                                      setPassprof('');
                                      setPassprofconf('');
                                    }}
                                    style={{ width: '140px' }}
                                  />
                                </div>
                              </div>
                              <div className="row">
                              <div className="col-md-1"></div>
                                <div className="col-md-10 txt-aln">
                                  <div className="alert alert-light-primary light fade show text-dark border-left-wrapper " role="alert">
                                 
                                    <p style={{textAlign:'center'}}> <i className="fa fa-info-circle" aria-hidden="true"></i> The password must be at least 8 characters.<br/>
                                    <i className="fa fa-info-circle" aria-hidden="true"></i> The password must contain at least one uppercase letter, one lowercase letter, and one number.
                                    </p>
                                  
                                  </div>

                                </div>
                              </div>


                            </div>
                          ) : null}


                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

      </Template>
    </>
  );
}
